export default __webpack_public_path__ + "static/media/fassaden4.568df81c.jpg";